import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.background.default,
        borderTop: `1px solid ${theme.palette.divider}`
    },
    alert: {
        padding: "2rem 4rem",
        backgroundColor: "black",
        borderRadius: "0.5rem",
        color: "white",
        textAlign: "center",
        fontSize: "1rem"
    }
}));

const LoadingWidget: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <span className={classes.alert}>
                Laden...
                <br />
                Bitte warten Sie einen Moment.
            </span>
        </div>
    );
};

export default LoadingWidget;
